import Constants from "../constants/constants";
import { userStore } from "../stores/user";
import { storeUtils } from "../stores/util";

export const ServerAPI = {
  callRequestListControllerWithParams: function (filterParams) {
    filterParams.isDispacher = false;
    if (userStore.getSelectedRole().indexOf(Constants.Roles.DISPATCHER) == 0) {
      filterParams.isDispacher = true;
    }
    console.log(filterParams);
    return $.ajax({
      type: "POST",
      contentType: "application/json",
      headers: {
        Authorization: `Bearer ${window.gritConfig.authUser.access_token}`,
      },
      url: storeUtils.URL_ROOT + "requestList/requestList",
      data: JSON.stringify(filterParams),
      dataType: "json",
    });
  },
  getActiveList: function (filterParams) {
    return $.ajax({
      type: "POST",
      contentType: "application/json",
      headers: {
        Authorization: `Bearer ${window.gritConfig.authUser.access_token}`,
      },
      url: storeUtils.URL_ROOT + "requestList/getActiveList",
      data: JSON.stringify(filterParams),
      dataType: "json",
    });
  },

  getActiveListForSub: function (sub) {
    return $.ajax({
      type: "POST",
      contentType: "application/json",
      headers: {
        Authorization: `Bearer ${window.gritConfig.authUser.access_token}`,
      },
      url: storeUtils.URL_ROOT + "requestList/getActiveListForSub",
      data: JSON.stringify({ subdivision: sub }),
      dataType: "json",
    });
  },

  getRecentListForSub: function (sub, hours) {
    return $.ajax({
      type: "POST",
      contentType: "application/json",
      headers: {
        Authorization: `Bearer ${window.gritConfig.authUser.access_token}`,
      },
      url: storeUtils.URL_ROOT + "requestList/getRecentListForSub",
      data: JSON.stringify({ subdivision: sub, hours: hours }),
      dataType: "json",
    });
  },

  getActiveListForSubAndFormType: function (sub, formType, subTabTypeVal) {
    return $.ajax({
      type: "POST",
      contentType: "application/json",
      headers: {
        Authorization: `Bearer ${window.gritConfig.authUser.access_token}`,
      },
      url: storeUtils.URL_ROOT + "requestList/getActiveListForSubAndFormType",
      data: JSON.stringify({
        subdivision: sub,
        formTypeParm: formType,
        subTabTypeVal: subTabTypeVal,
      }),
      dataType: "json",
    });
  },

  getRequestHistory: function (reqId) {
    return $.ajax({
      type: "GET",
      contentType: "application/json",
      headers: {
        Authorization: `Bearer ${window.gritConfig.authUser.access_token}`,
      },
      url: storeUtils.URL_ROOT + "requestHistory/" + reqId,
      dataType: "json",
    });
  },

  getOutageList: function () {
    return $.ajax({
      type: "GET",
      contentType: "application/json",
      headers: {
        Authorization: `Bearer ${window.gritConfig.authUser.access_token}`,
      },
      url: storeUtils.URL_ROOT + "outage/list",
      dataType: "json",
    });
  },

  createOutage: function (data) {
    return $.ajax({
      type: "POST",
      contentType: "application/json",
      headers: {
        Authorization: `Bearer ${window.gritConfig.authUser.access_token}`,
      },
      url: storeUtils.URL_ROOT + "outage/add",
      dataType: "json",
      data: JSON.stringify(data),
    });
  },

  updateOutage: function (data) {
    return $.ajax({
      type: "PUT",
      contentType: "application/json",
      headers: {
        Authorization: `Bearer ${window.gritConfig.authUser.access_token}`,
      },
      url: storeUtils.URL_ROOT + "outage/update/" + data.id,
      dataType: "json",
      data: JSON.stringify(data),
    });
  },

  deleteOutage: function (outageId) {
    return $.ajax({
      type: "DELETE",
      contentType: "application/json",
      headers: {
        Authorization: `Bearer ${window.gritConfig.authUser.access_token}`,
      },
      url: storeUtils.URL_ROOT + "outage/delete/" + outageId,
    });
  },

  getItemList: function () {
    return $.ajax({
      type: "POST",
      contentType: "application/json",
      headers: {
        Authorization: `Bearer ${window.gritConfig.authUser.access_token}`,
      },
      url: storeUtils.URL_ROOT + "sls/getItems",
      dataType: "json",
    });
  },

  getItem: function (params) {
    return $.ajax({
      type: "POST",
      contentType: "application/json",
      headers: {
        Authorization: `Bearer ${window.gritConfig.authUser.access_token}`,
      },
      url: storeUtils.URL_ROOT + "sls/getItem",
      data: JSON.stringify(params),
      dataType: "json",
    });
  },
  updateItem: function (item) {
    return $.ajax({
      type: "POST",
      contentType: "application/json",
      headers: {
        Authorization: `Bearer ${window.gritConfig.authUser.access_token}`,
      },
      url: storeUtils.URL_ROOT + "sls/updateItem",
      data: JSON.stringify(item),
      dataType: "json",
    });
  },
  resendItem: function (item, printLata) {
    return $.ajax({
      type: "POST",
      contentType: "application/json",
      headers: {
        Authorization: `Bearer ${window.gritConfig.authUser.access_token}`,
      },
      url: storeUtils.URL_ROOT + "sls/resendMessage",
      data: JSON.stringify({ restriction: item, printLata: printLata }),
      dataType: "json",
    });
  },
  calculateGuidsForPushedItems: function (sub) {
    return $.ajax({
      type: "POST",
      contentType: "application/json",
      headers: {
        Authorization: `Bearer ${window.gritConfig.authUser.access_token}`,
      },
      url: storeUtils.URL_ROOT + "sls/calculatePushedGuids",
      data: JSON.stringify(sub),
      dataType: "json",
    });
  },
  getOverrideUsers: function () {
    return $.ajax({
      type: "POST",
      contentType: "application/json",
      headers: {
        Authorization: `Bearer ${window.gritConfig.authUser.access_token}`,
      },
      url: storeUtils.URL_ROOT + "override/users",
      dataType: "json",
    });
  },
  getActiveOverrideForUser: function (user) {
    return $.ajax({
      type: "POST",
      contentType: "application/json",
      headers: {
        Authorization: `Bearer ${window.gritConfig.authUser.access_token}`,
      },
      url: storeUtils.URL_ROOT + "overrideUser/getForUser",
      dataType: "json",
      data: JSON.stringify(user),
    });
  },
  getDefaultTracks: function () {
    return $.ajax({
      type: "POST",
      contentType: "application/json",
      headers: {
        Authorization: `Bearer ${window.gritConfig.authUser.access_token}`,
      },
      url: storeUtils.URL_ROOT + "defaultTrack/list",
      dataType: "json",
    });
  },
  //get reason code
  getReasonCodes: function () {
    return $.ajax({
      type: "POST",
      contentType: "application/json",
      headers: {
        Authorization: `Bearer ${window.gritConfig.authUser.access_token}`,
      },
      url: storeUtils.URL_ROOT + "reasonCode/list",
      dataType: "json",
    });
  },
  getUserDetails: function () {
    return $.ajax({
      type: "POST",
      contentType: "application/json",
      headers: {
        Authorization: `Bearer ${window.gritConfig.authUser.access_token}`,
      },
      url: storeUtils.URL_ROOT + "userDetails/list",
      dataType: "json",
    });
  },
  //Fetch pattern maintenance details
  getPatternMaintenance: function () {
    return $.ajax({
      type: "GET",
      contentType: "application/json",
      headers: {
        Authorization: `Bearer ${window.gritConfig.authUser.access_token}`,
      },
      url: storeUtils.URL_ROOT + "patternMaintenance/list",
      dataType: "json",
    });
  },
  //Update Default Track
  updateDefaultTrack: function (defaultTrack) {
    return $.ajax({
      type: "POST",
      contentType: "application/json",
      headers: {
        Authorization: `Bearer ${window.gritConfig.authUser.access_token}`,
      },
      url: storeUtils.URL_ROOT + "defaultTrack/save",
      dataType: "json",
      data: JSON.stringify(defaultTrack),
    });
  },
  //Update Reason Code
  updateReasonCode: function (reasonCode) {
    return $.ajax({
      type: "POST",
      contentType: "application/json",
      headers: {
        Authorization: `Bearer ${window.gritConfig.authUser.access_token}`,
      },
      url: storeUtils.URL_ROOT + "reasonCode/save",
      dataType: "json",
      data: JSON.stringify(reasonCode),
    });
  },
  updateGritUser: function (gritUser) {
    return $.ajax({
      type: "POST",
      contentType: "application/json",
      headers: {
        Authorization: `Bearer ${window.gritConfig.authUser.access_token}`,
      },
      url: storeUtils.URL_ROOT + "userDetails/save",
      dataType: "json",
      data: JSON.stringify(gritUser),
    });
  },
  //update pattern details
  updatePatternMaint: function (patternData) {
    return $.ajax({
      type: "POST",
      contentType: "application/json",
      headers: {
        Authorization: `Bearer ${window.gritConfig.authUser.access_token}`,
      },
      url: storeUtils.URL_ROOT + "patternMaintenance/save",
      dataType: "json",
      data: JSON.stringify(patternData),
    });
  },
  updateExistingPatternMaint: function (patternData) {
    return $.ajax({
      type: "PUT",
      contentType: "application/json",
      headers: {
        Authorization: `Bearer ${window.gritConfig.authUser.access_token}`,
      },
      url: storeUtils.URL_ROOT + `patternMaintenance/${patternData.id}`,
      dataType: "json",
      data: JSON.stringify(patternData),
    });
  },
  deletePatternMaint: function (patternId) {
    return $.ajax({
      type: "DELETE",
      headers: {
        Authorization: `Bearer ${window.gritConfig.authUser.access_token}`,
      },
      url: storeUtils.URL_ROOT + `patternMaintenance/${patternId}`,
    });
  },
  deleteGritUser: function (bNumber) {
    return $.ajax({
      type: "DELETE",
      contentType: "application/json",
      headers: {
        Authorization: `Bearer ${window.gritConfig.authUser.access_token}`,
      },
      url: storeUtils.URL_ROOT + "userDetails/delete/" + bNumber,
      dataType: "json"
    });
  },
  //Delete Default Track
  deleteDefaultTrack: function (trackId) {
    return $.ajax({
      type: "DELETE",
      contentType: "application/json",
      headers: {
        Authorization: `Bearer ${window.gritConfig.authUser.access_token}`,
      },
      url: storeUtils.URL_ROOT + "defaultTrack/delete/" + trackId
    });
  },
  submitNewOverrideUser: function (override) {
    return $.ajax({
      type: "POST",
      contentType: "application/json",
      headers: {
        Authorization: `Bearer ${window.gritConfig.authUser.access_token}`,
      },
      url: storeUtils.URL_ROOT + "overrideUser/create",
      dataType: "json",
      data: JSON.stringify(override),
    });
  },
  expireOverrideUser: function (id) {
    return $.ajax({
      type: "POST",
      contentType: "application/json",
      headers: {
        Authorization: `Bearer ${window.gritConfig.authUser.access_token}`,
      },
      url: storeUtils.URL_ROOT + "overrideUser/expire",
      dataType: "json",
      data: JSON.stringify(id),
    });
  },
  calculateTracks: function (restriction) {
    var trackCalculationData = {
      restriction: restriction,
      environment: window.gritConfig.gisEnvironment,
      actionTime: Date.now(),
    };
    return $.ajax({
      type: "POST",
      contentType: "application/json",
      headers: {
        Authorization: `Bearer ${window.gritConfig.authUser.access_token}`,
      },
      url: storeUtils.URL_ROOT + "trackCalculation/calculateTracks",
      dataType: "json",
      data: JSON.stringify(trackCalculationData),
    });
  },
  saveCompareResult: function (data) {
    return $.ajax({
      type: "POST",
      contentType: "application/json",
      headers: {
        Authorization: `Bearer ${window.gritConfig.authUser.access_token}`,
      },
      url: storeUtils.URL_ROOT + "requestList/saveCompareResult",
      data: JSON.stringify(data),
      dataType: "json",
    });
  },
  getServerCompareResult: function (data, schematic) {
    return $.ajax({
      type: "POST",
      contentType: "application/json",
      headers: {
        Authorization: `Bearer ${window.gritConfig.authUser.access_token}`,
      },
      url: storeUtils.URL_ROOT + "requestList/retrieveCompareResult",
      data: JSON.stringify({ subdivision: data, schematic: schematic }),
      dataType: "json",
    });
  },
  getRestrictionPrintList: function (filterParams) {
    return $.ajax({
      type: "POST",
      contentType: "application/json",
      headers: {
        Authorization: `Bearer ${window.gritConfig.authUser.access_token}`,
      },
      url: storeUtils.URL_ROOT + "requestList/retrievePrintIssuedList",
      data: JSON.stringify(filterParams),
      dataType: "json",
    });
  },

  getSubdivisionLocations: function (subdivision) {
    return $.ajax({
      type: "POST",
      contentType: "application/json",
      headers: {
        Authorization: `Bearer ${window.gritConfig.authUser.access_token}`,
      },
      url: storeUtils.URL_ROOT + "requestList/subdivisionLocations",
      data: JSON.stringify({ subdivision: subdivision }),
      dataType: "json",
    });
  },
};
